import { RequireOnly } from '@pelicargo/types';
import { modelUtils } from '@pelicargo/utils';
import { Cargo } from '@prisma/client';

export const mayImpactCw = (cargos: RequireOnly<Cargo, 'length' | 'width' | 'weight' | 'handling'>[]) => {
  return cargos?.some(modelUtils.cargo.mayImpactCw);
};
